export default {
  reservationsApiUrl: '/api/reservations'
};